import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './Reject.module.css';

export default class Reject extends React.PureComponent {
    static propTypes = {
        caption: PropTypes.node,
        align: PropTypes.oneOf(['left', 'right']),
        isPublish: PropTypes.bool,
        onClick: PropTypes.func.isRequired,
    }

    render() {
        /*const classNameBase = classNames(styles.base, {
            [styles[`base__${this.props.align}`]]: this.props.align,
        })*/
        const classNameBase = !this.props.isPublish ? styles.base : styles.base_pub
        const classNameBaseAll = classNames(classNameBase, {
            [styles[`base__${this.props.align}`]]: this.props.align,
        })

        return (
            <div className={classNameBaseAll} onClick={this.props.onClick}>{this.props.caption}</div>
        )
    }
}
